export default "__VITE_ASSET__e545c846__"